import React from 'react';

import { Paper, Typography, Divider, Grid } from '@mui/material';

interface SysInfoPaneProps {
  record: {
    createdBy: string;
    createdDate: string;
    modifiedBy: string;
    modifiedDate: string;
  };
}

const SysInfoPane: React.FC<SysInfoPaneProps> = ({ record }: SysInfoPaneProps) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Audit Information
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={3}>
        <Grid>
          <Typography variant="caption" color="text.secondary">
            Created By
          </Typography>
          <Typography variant="body1">{record.createdBy}</Typography>
        </Grid>
        <Grid>
          <Typography variant="caption" color="text.secondary">
            Created Date
          </Typography>
          <Typography variant="body1">{new Date(record.createdDate).toLocaleString()}</Typography>
        </Grid>
        <Grid>
          <Typography variant="caption" color="text.secondary">
            Last Modified By
          </Typography>
          <Typography variant="body1">{record.modifiedBy}</Typography>
        </Grid>
        <Grid>
          <Typography variant="caption" color="text.secondary">
            Last Modified Date
          </Typography>
          <Typography variant="body1">{new Date(record.modifiedDate).toLocaleString()}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SysInfoPane;
